export function projectStorageBasePath(mmCode: number): string {
  return `/projects/${mmCode}`;
}
